import apps from "@services/applications";
import { RouteLocation } from "vue-router";

export default [
  {
    path: "/app/export",
    name: "export",
    meta: {
      module: "exports",
      title: "Exports"
    },
    component: () => import("@Exports/views/GeneralExports.vue"),
    children: [
      {
        path: ":type/:id?",
        name: "create-export",
        meta: {
          application: function (route: RouteLocation) {
            const appName = route.params.type as string;
            return apps["Exports"][appName]?.Id || apps["PrintCatalogs"][appName]?.Id;
          },
          licenseName: (route: RouteLocation) => {
            const appName = route.params.type as string;
            if (appName === "FastPage") return ["WebClientConcurrentFastPageUsers", "WebClientNamedFastPageUsers"];
            if (appName === "Ariba") return ["AribaConnector"];
            return;
          },
          authenticatedRoute: true
        },
        component: () => import("@Exports/components/CreateExport.vue")
      },
      {
        path: "progress/:type/:id",
        name: "progress-export",
        meta: {
          authenticatedRoute: true
        },
        component: () => import("@Exports/components/ProgressExport.vue")
      },
      {
        path: "export-settings/:type/:id",
        name: "export-settings-viewer",
        meta: {
          authenticatedRoute: true
        },
        component: () => import("@Exports/components/ExportSettingsViewer.vue")
      }
    ]
  },
  {
    path: "/app/combit-designer/:id/:layout?",
    name: "fastpage-designer",
    meta: {
      authenticatedRoute: true,
      application: apps["PrintCatalogs"]["FastPage"].Id,
      licenseName: ["WebClientConcurrentFastPageUsers", "WebClientNamedFastPageUsers"]
    },
    component: () => import("@Exports/components/FastPage/WebReportDesignerView.vue")
  },
  {
    path: "/app/combit-desktop-designer/:id/:layout?",
    name: "fastpage-desktop-designer",
    meta: {
      authenticatedRoute: true,
      application: apps["PrintCatalogs"]["FastPage"].Id,
      licenseName: ["WebClientConcurrentFastPageUsers", "WebClientNamedFastPageUsers"]
    },
    component: () => import("@Exports/components/FastPage/DesktopDesignerView.vue")
  }
];
